// @mui
import { Box } from "@mui/material"
import type { BoxProps } from "@mui/material"
import { forwardRef, useContext } from "react"
import { Helmet } from "react-helmet-async"
import { useTranslation } from "react-i18next"

import { DomainContext } from "@/routes/providers/originals"

import { APP_NAME, APP_NAME_ORIGINALS } from "../config"

// ----------------------------------------------------------------------

const Page = forwardRef(
  (
    {
      children,
      title = "",
      meta,
      ...other
    }: {
      children: React.ReactNode
      title?: string
      meta?: React.ReactNode
    } & BoxProps,
    ref
  ) => {
    const { isOriginals } = useContext(DomainContext)
    const { t, i18n } = useTranslation()
    const appName = t(isOriginals ? APP_NAME_ORIGINALS : APP_NAME)
    const siteTitle = t(isOriginals ? "seo.titleOriginals" : "seo.title")
    const siteName = t(isOriginals ? "seo.siteNameOriginals" : "seo.siteName")
    const description = t(isOriginals ? "seo.descriptionOriginals" : "seo.description")
    const documentTitle = title ? `${title} | ${appName}` : siteTitle
    const pageUrl = `${window.location.origin}${window.location.pathname}`

    return (
      <>
        <Helmet>
          <html lang={i18n.language} />
          <title>{documentTitle}</title>
          <meta name="description" content={description} />
          <link rel="canonical" href={pageUrl} />
          <meta property="og:title" content={documentTitle} />
          <meta property="og:description" content={description} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={pageUrl} />
          <meta property="og:site_name" content={siteName} />
          {meta}
        </Helmet>

        <Box ref={ref} sx={{ overflowX: "clip" }} {...other}>
          {children}
        </Box>
      </>
    )
  }
)

export default Page
